import { inject } from '@angular/core';
import type {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot,
} from '@angular/router';
import { Location } from '@freelancer/location';
import { LOGIN_AUTH_SERVICE, LOGIN_CONFIG } from '@freelancer/login';
import { map } from 'rxjs/operators';

export const SignupGuard = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): ReturnType<CanActivateFn> => {
  const auth = inject(LOGIN_AUTH_SERVICE);
  const loginConfig = inject(LOGIN_CONFIG);
  const location = inject(Location);

  if (loginConfig.ssoIntegration) {
    return location.createUrlTree(['/saml_sso/sso.php'], {
      queryParams: {
        ...route.queryParams,
        integration: loginConfig.ssoIntegration,
      },
    });
  }

  return auth.isLoggedIn().pipe(
    map(loggedIn => {
      const { next } = route.queryParams;
      if (loggedIn) {
        return location.createUrlTree([next || '/']);
      }
      return true;
    }),
  );
};
